<template>
    <div class="col backgroundForm">
        <h3 clas="col" align="center">{{ title }} </h3>
        <div class="row">
            <div class="col-12 col-sm-6">               
                <div class="col">
                
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                        <label class="btn btn-success active" @click="mViewSearch">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch"  value="enrollment" checked> Nombre
                        </label>
                        <label class="btn btn-success" @click="mViewSearch">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="name"> Matricula
                        </label>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label for="recipient-name" class="col-form-label">{{searchType}}</label>
                                <vue-bootstrap-typeahead                                        
                                        v-model="query"
                                        :data="boatsEnrollment"
                                        :serializer="item => (item.name_boat + ' ' + ( item.enrollment_old ? item.enrollment_old : item.enrollment) )"
                                        @hit="mSelectedBoat"
                                        :placeholder="searchType"
                                        :max-matches="maxResult"
                                        v-if="viewSearch"
                                        
                                    />
                                <vue-bootstrap-typeahead                                        
                                        v-model="query"
                                        :data="boatsEnrollment"
                                        :serializer="item => (item.name_boat + ' ' + (item.enrollment_old ? item.enrollment_old : item.enrollment ) )"
                                        @hit="mSelectedBoat"
                                        :placeholder="searchType"
                                        :max-matches="maxResult"
                                        v-else
                                    />
                        </div>
                    </div>
                </div>
                <transition name="fade" mode="out-in">
                <div class="col" v-if="dSelect">
                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-4 col-form-label"><b>Matricula:</b></label>
                        <div class="col-sm-8">
                            
                            <input v-if="selectedBoat.enrollment" type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="selectedBoat.enrollment">
                            <input v-else type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="selectedBoat.enrollment_old">
                        </div>

                        <label for="staticEmail" class="col-sm-4 col-form-label"><b>Nombre:</b></label>
                        <div class="col-sm-8">
                            <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="selectedBoat.name_boat">
                        </div>

                        <label for="staticEmail" class="col-sm-4 col-form-label"><b>Tipo:</b></label>
                        <div class="col-sm-8">
                            <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="selectedBoat.detail_boat">
                        </div>
                        <label for="staticEmail" class="col-sm-4 col-form-label"><b>Propulsion:</b></label>
                        <div class="col-sm-8">
                            <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="selectedBoat.detail_propulsion">
                        </div>
                        <label for="staticEmail" class="col-sm-4 col-form-label"><b>TRB:</b></label>
                        <div class="col-sm-8">
                            <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="selectedBoat.trb">
                        </div>
                        <label for="staticEmail" class="col-sm-4 col-form-label"><b>TRN:</b></label>
                        <div class="col-sm-8">
                            <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="selectedBoat.trn">
                        </div>
                    </div>
                </div>
                </transition>
                
            </div>
            <div align="center" class="col-12 col-sm-6" id="imageShip">
                <image-uploader
                :preview="true"
                :className="['fileinput' ,{ 'fileinput--loaded': hasImage }]"
                capture="environment"
                :debug="1"
                doNotResize="gif"
                :scaleRatio="scaleImage"
                :quality="qualityImage"
                :autoRotate="true"
                outputFormat="verbose"
                @input="setImage"
            >
            
                <label for="fileInput" slot="upload-label" class="col">
                <div><font-awesome-icon icon="camera-retro" size="3x"></font-awesome-icon></div>
                <span class="upload-caption">{{
                    hasImage ? "Cambiar" : "Seleccionar Foto"
                }}</span>
                </label>
                </image-uploader>
            </div>
        </div>       
        <div align="center">
            <transition name="fade">
            <button class="btn btn-outline-primary" @click="sendPhotoShip" v-if="btnUp">Subir <font-awesome-icon icon="upload" ></font-awesome-icon></button>
            </transition>
        </div>

        <modal-loading :id-modal="idModalL" :title="modalLoadTitle" :status-send="sendRequest" ></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';

import modalLoading from '../modal/modalLoading';

const qs= require('qs');

export default {
    name:'upload-photo',
    data(){
        return{
            maxResult:50,
            idModalL:'upLoading',
            modalLoadTitle:'Subiendo...',
            sendRequest:true,
            title:'Añadir Foto a Embarcación',
            hasImage:false,
            scaleImage:0.85,
            qualityImage:0.9,
            ship:{
                id:'',
                image:null
            },
            selectedBoat: {
                id_boat:0,
                name_boat:null,
                enrollment:null,
                enrollment_old:null,
                detail_boat:null,
                detail_propulsion:null,
                trb:null,
                trn:null,
                factor_propulsion:null,
                flag:null,
                flag_boat:null
            },
            optionSearch:'name',
            boatsEnrollment: [],
            query:'',
            dSelect:false
        }
    },
    methods:{
        setImage(output){
            this.hasImage=true;
            this.ship.image=output.dataUrl;
            
            // console.log(this.ship.image);
        },
        async sendPhotoShip(){
            this.mShowModalUP(this.idModalL);

            
            try {
                let sa={
                    id:this.selectedBoat.id_boat,
                    image:this.ship.image
                }
                // let fu= await axios.post(`upPhotoShip`, qs.stringify(sa));
                let fu= await axios.post(`upPhotoShip?api_token=${Vue.auth.getToken()}`, qs.stringify(sa));
                
                if(fu.data[1].id_rep !== 0){
                    toastr.success(fu.data[0].respuesta, 'Exito');
                }else{
                    toastr.error(fu.data[0].respuesta, 'Error');
                }

                this.ship.image=null;
                this.hasImage=false;
                document.getElementsByClassName('img-preview')[0].src="";
            } catch (error) {
                console.log(error)
            }            

            setTimeout(()=>{                
                    this.mCloseModalUP(this.idModalL);
            }, 1000)
        },
        mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            //console.log(radioV);
            this.optionSearch=radioV;
        },
        mSelectedBoat(data){
            
            this.selectedBoat=data;
            this.dSelect=true;
            // console.log(this.selectedBoat);
        },
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        }
    },
    computed:{
        btnUp(){
            if(this.ship.image != null && this.selectedBoat.id_boat != '')
                return true;
            else
                return false;
        },
        searchType(){
            switch(this.optionSearch){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
        viewSearch(){
            switch(this.optionSearch){
                case 'name':
                    this.vSearch=true;
                break;

                case 'enrollment':
                    this.vSearch=false;
                break;
            }
            return this.vSearch;
        },
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    },
    watch:{
        query(newQuery) {
            if(newQuery.length > 2){
            
                axios.get(`searchShipPhotoWeb/${this.optionSearch}/${newQuery}/${this.cSessionUser.portId}?api_token=${Vue.auth.getToken()}`)
                    .then((res) => {
                        // console.log(res.data);           
                        this.boatsEnrollment = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }               
        }
    },
    components:{
        'modal-loading':modalLoading
    }
}
</script>

<style>
#imageShip img{
    width: 250px;
}

#fileInput {
  display: none;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.my-8 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/matriculacion/UploadPhoto.vue